/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * credential: 跨域
 *
 */


const dev = {
  routerMode: "history",
  
  baseUrl: process.env.VUE_APP_BASEURL
    ? process.env.VUE_APP_BASEURL
    // : "http://127.0.0.1:1703", //本地环境
     : "https://api.zh2580.com", //致和生产环境

  credential: true
};

export default dev;



// WEBPACK FOOTER //
// ./src/config/env.js